/* tslint:disable */
/* eslint-disable */
/**
 * MONEI API v1
 * The MONEI API is organized around REST principles. Our API is designed to be intuitive and developer-friendly.  ### Base URL  All API requests should be made to:  ``` https://api.monei.com/v1 ```  ### Environment  MONEI provides two environments:  - **Test Environment**: For development and testing without processing real payments - **Live Environment**: For processing real transactions in production  ### Client Libraries  We provide official SDKs to simplify integration:  - [PHP SDK](https://github.com/MONEI/monei-php-sdk) - [Python SDK](https://github.com/MONEI/monei-python-sdk) - [Node.js SDK](https://github.com/MONEI/monei-node-sdk) - [Postman Collection](https://postman.monei.com/)  Our SDKs handle authentication, error handling, and request formatting automatically.  You can download the OpenAPI specification from the https://js.monei.com/api/v1/openapi.json and generate your own client library using the [OpenAPI Generator](https://openapi-generator.tech/).  ### Important Requirements  - All API requests must be made over HTTPS - If you are not using our official SDKs, you **must provide a valid `User-Agent` header** with each request - Requests without proper authentication will return a `401 Unauthorized` error  ### Error Handling  The API returns consistent error codes and messages to help you troubleshoot issues. Each response includes a `statusCode` attribute indicating the outcome of your request.  ### Rate Limits  The API implements rate limiting to ensure stability. If you exceed the limits, requests will return a `429 Too Many Requests` status code.
 *
 * The version of the OpenAPI document: 1.7.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from '../axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction
} from '../common';
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from '../base';
// @ts-ignore
import type {ActivateSubscriptionRequest} from '../model';
// @ts-ignore
import type {BadRequestError} from '../model';
// @ts-ignore
import type {CancelSubscriptionRequest} from '../model';
// @ts-ignore
import type {CreateSubscriptionRequest} from '../model';
// @ts-ignore
import type {InternalServerError} from '../model';
// @ts-ignore
import type {NotFoundError} from '../model';
// @ts-ignore
import type {PauseSubscriptionRequest} from '../model';
// @ts-ignore
import type {Payment} from '../model';
// @ts-ignore
import type {SendSubscriptionLinkRequest} from '../model';
// @ts-ignore
import type {SendSubscriptionStatusRequest} from '../model';
// @ts-ignore
import type {ServiceUnavailableError} from '../model';
// @ts-ignore
import type {Subscription} from '../model';
// @ts-ignore
import type {UnauthorizedError} from '../model';
// @ts-ignore
import type {UnprocessableEntityError} from '../model';
// @ts-ignore
import type {UpdateSubscriptionRequest} from '../model';
/**
 * SubscriptionsApi - axios parameter creator
 * @export
 */
export const SubscriptionsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Activates a subscription by attaching a payment method and initiating the billing cycle.  **Activation Process**:  1. This endpoint transitions a `PENDING` subscription to `ACTIVE` status 2. An initial payment is created to validate the payment method:    - For regular subscriptions: First billing cycle payment is processed immediately    - For trial subscriptions: A zero-amount payment is created to verify the payment method  **Payment Method Updates**: If the subscription is already active, this endpoint can be used to update the payment method. The update process creates a zero-amount payment to verify the new payment method works correctly.  **Important Notes**:  - Subscription billing begins immediately upon successful activation (unless in trial period) - The payment method provided will be used for all future recurring charges - Activation failures (due to invalid payment method) will keep the subscription in `PENDING` status
     * @summary Activate Subscription
     * @param {string} id The subscription ID
     * @param {ActivateSubscriptionRequest} [activateSubscriptionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activate: async (
      id: string,
      activateSubscriptionRequest?: ActivateSubscriptionRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('activate', 'id', id);
      const localVarPath = `/subscriptions/{id}/activate`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication APIKey required
      await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        activateSubscriptionRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Cancels an active subscription, permanently stopping the billing cycle.  **Cancellation Effects**:  - The subscription status changes to `CANCELED` - No further charges will be processed - Access to subscription services typically ends immediately or at period end (depending on your business rules)  **Important Notes**:  - Cancellation is permanent and cannot be undone - To restart service, a new subscription must be created - Consider using `pauseAtPeriodEnd` or `cancelAtPeriodEnd` for softer transitions  Use this endpoint when a customer wishes to completely terminate their subscription.
     * @summary Cancel Subscription
     * @param {string} id The subscription ID
     * @param {CancelSubscriptionRequest} [cancelSubscriptionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancel: async (
      id: string,
      cancelSubscriptionRequest?: CancelSubscriptionRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('cancel', 'id', id);
      const localVarPath = `/subscriptions/{id}/cancel`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication APIKey required
      await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        cancelSubscriptionRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Creates a new subscription with the specified parameters.  **Subscription Lifecycle**:  1. When first created, the subscription has a `PENDING` status 2. To initiate billing, you must call the [activate endpoint](https://docs.monei.com/apis/rest/subscriptions-activate/) with payment details 3. Once activated, the subscription will automatically bill according to the configured interval  **Key Configuration Parameters**:  - **Billing settings**: Amount, currency, interval (daily, weekly, monthly, yearly) - **Schedule customization**: Interval count, trial period duration - **Customer information**: Contact details, billing and shipping addresses - **Communication**: Callback URLs for webhook notifications about subscription events  **Best Practices**:  - Set clear, descriptive names for subscriptions to help with identification - Configure appropriate webhook notifications to monitor subscription status changes - Consider offering trial periods to increase customer conversion rates - Use metadata to store additional information relevant to your business logic
     * @summary Create Subscription
     * @param {CreateSubscriptionRequest} createSubscriptionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    create: async (
      createSubscriptionRequest: CreateSubscriptionRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createSubscriptionRequest' is not null or undefined
      assertParamExists('create', 'createSubscriptionRequest', createSubscriptionRequest);
      const localVarPath = `/subscriptions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication APIKey required
      await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createSubscriptionRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Retrieves the complete details of an existing subscription by its unique ID.  This endpoint returns comprehensive information about the subscription, including:  - Current status and lifecycle details (active, paused, canceled) - Billing configuration (amount, currency, interval) - Schedule information (current period, next payment date) - Customer and payment method details - Payment history (including last payment status) - Trial period information (if applicable)  Use this endpoint to check subscription status, verify billing details, or retrieve information needed for customer support inquiries.
     * @summary Get Subscription
     * @param {string} id The subscription ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('get', 'id', id);
      const localVarPath = `/subscriptions/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication APIKey required
      await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Pauses an active subscription, temporarily halting the billing cycle.  **Pause Effects**:  - Billing is immediately suspended - The subscription status changes to `PAUSED` - No charges will be processed while the subscription remains paused - The current billing period end date remains unchanged  **Use Cases**:  - Temporary service interruptions - Customer vacation or absence periods - Account maintenance or dispute resolution  To resume billing, use the [resume endpoint](https://docs.monei.com/apis/rest/subscriptions-resume/).
     * @summary Pause Subscription
     * @param {string} id The subscription ID
     * @param {PauseSubscriptionRequest} [pauseSubscriptionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pause: async (
      id: string,
      pauseSubscriptionRequest?: PauseSubscriptionRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('pause', 'id', id);
      const localVarPath = `/subscriptions/{id}/pause`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication APIKey required
      await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        pauseSubscriptionRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Resumes a previously paused subscription, reactivating the billing cycle.  **Resume Effects**:  - Billing is immediately reactivated - The subscription status changes from `PAUSED` to `ACTIVE` - The next billing date is recalculated based on the current date - Regular charging schedule resumes according to the subscription interval  **Important Notes**:  - No immediate charge is created when resuming (billing continues on next scheduled date) - Any pause duration is added to the current billing period, maintaining the expected number of billing cycles - If a significant time has passed, verify that the payment method is still valid
     * @summary Resume Subscription
     * @param {string} id The subscription ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resume: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('resume', 'id', id);
      const localVarPath = `/subscriptions/{id}/resume`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication APIKey required
      await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Sends a subscription activation link to the customer through their preferred communication channel.  **This API can only be used for subscriptions with the following status:**  - Pending  **Delivery channels are automatically selected based on available customer information:**  - If customer email is available: Link is sent via email - If customer phone is available: Link is sent via WhatsApp - If WhatsApp delivery fails: Link is sent via SMS as a fallback  The subscription activation link allows customers to complete their subscription setup by providing payment details on the secure MONEI payment page. If no customer contact information is provided, the system will use the details stored in the subscription record.
     * @summary Send Subscription Link
     * @param {string} id The subscription ID
     * @param {SendSubscriptionLinkRequest} [sendSubscriptionLinkRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendLink: async (
      id: string,
      sendSubscriptionLinkRequest?: SendSubscriptionLinkRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('sendLink', 'id', id);
      const localVarPath = `/subscriptions/{id}/link`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication APIKey required
      await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        sendSubscriptionLinkRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Sends subscription status information to the customer through their preferred communication channel.  **This API can only be used for subscriptions with the following statuses:**  - Active - Trialing - Past due  **Delivery channels are automatically selected based on available customer information:**  - If customer email is available: Status is sent via email - If customer phone is available: Status is sent via WhatsApp - If WhatsApp delivery fails: Status is sent via SMS as a fallback  The status notification includes subscription details such as current status, upcoming payments, and recent changes. If no customer contact information is provided, the system will use the details stored in the subscription record.  **Email notifications include contextual action links based on subscription status:**  - For past due subscriptions: A link to reactivate the subscription - For active and trialing subscriptions: A link to update the payment method  You can specify the customer\'s email or phone number, the preferred communication channel (email or SMS), and the language for the message.
     * @summary Send Subscription Status
     * @param {string} id The subscription ID
     * @param {SendSubscriptionStatusRequest} [sendSubscriptionStatusRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendStatus: async (
      id: string,
      sendSubscriptionStatusRequest?: SendSubscriptionStatusRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('sendStatus', 'id', id);
      const localVarPath = `/subscriptions/{id}/status`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication APIKey required
      await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        sendSubscriptionStatusRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Updates the configuration of an existing subscription.  **Modifiable Parameters**:  - Billing information (amount, description) - Customer details (contact information, billing/shipping addresses) - Subscription settings (cancelAtPeriodEnd, pauseAtPeriodEnd) - Metadata (for your internal tracking)  **Update Effects**:  - Amount changes apply to the next billing cycle - Customer information updates take effect immediately - Setting `cancelAtPeriodEnd` to true will end the subscription after the current period - Setting `pauseAtPeriodEnd` to true will pause billing after the current period  **Note**: Some fundamental properties cannot be changed once a subscription is created, including currency and billing interval. To modify these, you would need to cancel the existing subscription and create a new one.
     * @summary Update Subscription
     * @param {string} id The subscription ID
     * @param {UpdateSubscriptionRequest} updateSubscriptionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    update: async (
      id: string,
      updateSubscriptionRequest: UpdateSubscriptionRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('update', 'id', id);
      // verify required parameter 'updateSubscriptionRequest' is not null or undefined
      assertParamExists('update', 'updateSubscriptionRequest', updateSubscriptionRequest);
      const localVarPath = `/subscriptions/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication APIKey required
      await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateSubscriptionRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};

/**
 * SubscriptionsApi - functional programming interface
 * @export
 */
export const SubscriptionsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SubscriptionsApiAxiosParamCreator(configuration);
  return {
    /**
     * Activates a subscription by attaching a payment method and initiating the billing cycle.  **Activation Process**:  1. This endpoint transitions a `PENDING` subscription to `ACTIVE` status 2. An initial payment is created to validate the payment method:    - For regular subscriptions: First billing cycle payment is processed immediately    - For trial subscriptions: A zero-amount payment is created to verify the payment method  **Payment Method Updates**: If the subscription is already active, this endpoint can be used to update the payment method. The update process creates a zero-amount payment to verify the new payment method works correctly.  **Important Notes**:  - Subscription billing begins immediately upon successful activation (unless in trial period) - The payment method provided will be used for all future recurring charges - Activation failures (due to invalid payment method) will keep the subscription in `PENDING` status
     * @summary Activate Subscription
     * @param {string} id The subscription ID
     * @param {ActivateSubscriptionRequest} [activateSubscriptionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activate(
      id: string,
      activateSubscriptionRequest?: ActivateSubscriptionRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Payment>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.activate(
        id,
        activateSubscriptionRequest,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SubscriptionsApi.activate']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Cancels an active subscription, permanently stopping the billing cycle.  **Cancellation Effects**:  - The subscription status changes to `CANCELED` - No further charges will be processed - Access to subscription services typically ends immediately or at period end (depending on your business rules)  **Important Notes**:  - Cancellation is permanent and cannot be undone - To restart service, a new subscription must be created - Consider using `pauseAtPeriodEnd` or `cancelAtPeriodEnd` for softer transitions  Use this endpoint when a customer wishes to completely terminate their subscription.
     * @summary Cancel Subscription
     * @param {string} id The subscription ID
     * @param {CancelSubscriptionRequest} [cancelSubscriptionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cancel(
      id: string,
      cancelSubscriptionRequest?: CancelSubscriptionRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Subscription>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cancel(
        id,
        cancelSubscriptionRequest,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SubscriptionsApi.cancel']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Creates a new subscription with the specified parameters.  **Subscription Lifecycle**:  1. When first created, the subscription has a `PENDING` status 2. To initiate billing, you must call the [activate endpoint](https://docs.monei.com/apis/rest/subscriptions-activate/) with payment details 3. Once activated, the subscription will automatically bill according to the configured interval  **Key Configuration Parameters**:  - **Billing settings**: Amount, currency, interval (daily, weekly, monthly, yearly) - **Schedule customization**: Interval count, trial period duration - **Customer information**: Contact details, billing and shipping addresses - **Communication**: Callback URLs for webhook notifications about subscription events  **Best Practices**:  - Set clear, descriptive names for subscriptions to help with identification - Configure appropriate webhook notifications to monitor subscription status changes - Consider offering trial periods to increase customer conversion rates - Use metadata to store additional information relevant to your business logic
     * @summary Create Subscription
     * @param {CreateSubscriptionRequest} createSubscriptionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async create(
      createSubscriptionRequest: CreateSubscriptionRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Subscription>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.create(
        createSubscriptionRequest,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SubscriptionsApi.create']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Retrieves the complete details of an existing subscription by its unique ID.  This endpoint returns comprehensive information about the subscription, including:  - Current status and lifecycle details (active, paused, canceled) - Billing configuration (amount, currency, interval) - Schedule information (current period, next payment date) - Customer and payment method details - Payment history (including last payment status) - Trial period information (if applicable)  Use this endpoint to check subscription status, verify billing details, or retrieve information needed for customer support inquiries.
     * @summary Get Subscription
     * @param {string} id The subscription ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async get(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Subscription>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.get(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SubscriptionsApi.get']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Pauses an active subscription, temporarily halting the billing cycle.  **Pause Effects**:  - Billing is immediately suspended - The subscription status changes to `PAUSED` - No charges will be processed while the subscription remains paused - The current billing period end date remains unchanged  **Use Cases**:  - Temporary service interruptions - Customer vacation or absence periods - Account maintenance or dispute resolution  To resume billing, use the [resume endpoint](https://docs.monei.com/apis/rest/subscriptions-resume/).
     * @summary Pause Subscription
     * @param {string} id The subscription ID
     * @param {PauseSubscriptionRequest} [pauseSubscriptionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pause(
      id: string,
      pauseSubscriptionRequest?: PauseSubscriptionRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Subscription>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pause(
        id,
        pauseSubscriptionRequest,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SubscriptionsApi.pause']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Resumes a previously paused subscription, reactivating the billing cycle.  **Resume Effects**:  - Billing is immediately reactivated - The subscription status changes from `PAUSED` to `ACTIVE` - The next billing date is recalculated based on the current date - Regular charging schedule resumes according to the subscription interval  **Important Notes**:  - No immediate charge is created when resuming (billing continues on next scheduled date) - Any pause duration is added to the current billing period, maintaining the expected number of billing cycles - If a significant time has passed, verify that the payment method is still valid
     * @summary Resume Subscription
     * @param {string} id The subscription ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resume(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Subscription>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.resume(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SubscriptionsApi.resume']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Sends a subscription activation link to the customer through their preferred communication channel.  **This API can only be used for subscriptions with the following status:**  - Pending  **Delivery channels are automatically selected based on available customer information:**  - If customer email is available: Link is sent via email - If customer phone is available: Link is sent via WhatsApp - If WhatsApp delivery fails: Link is sent via SMS as a fallback  The subscription activation link allows customers to complete their subscription setup by providing payment details on the secure MONEI payment page. If no customer contact information is provided, the system will use the details stored in the subscription record.
     * @summary Send Subscription Link
     * @param {string} id The subscription ID
     * @param {SendSubscriptionLinkRequest} [sendSubscriptionLinkRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sendLink(
      id: string,
      sendSubscriptionLinkRequest?: SendSubscriptionLinkRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Subscription>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sendLink(
        id,
        sendSubscriptionLinkRequest,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SubscriptionsApi.sendLink']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Sends subscription status information to the customer through their preferred communication channel.  **This API can only be used for subscriptions with the following statuses:**  - Active - Trialing - Past due  **Delivery channels are automatically selected based on available customer information:**  - If customer email is available: Status is sent via email - If customer phone is available: Status is sent via WhatsApp - If WhatsApp delivery fails: Status is sent via SMS as a fallback  The status notification includes subscription details such as current status, upcoming payments, and recent changes. If no customer contact information is provided, the system will use the details stored in the subscription record.  **Email notifications include contextual action links based on subscription status:**  - For past due subscriptions: A link to reactivate the subscription - For active and trialing subscriptions: A link to update the payment method  You can specify the customer\'s email or phone number, the preferred communication channel (email or SMS), and the language for the message.
     * @summary Send Subscription Status
     * @param {string} id The subscription ID
     * @param {SendSubscriptionStatusRequest} [sendSubscriptionStatusRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sendStatus(
      id: string,
      sendSubscriptionStatusRequest?: SendSubscriptionStatusRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Subscription>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sendStatus(
        id,
        sendSubscriptionStatusRequest,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SubscriptionsApi.sendStatus']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Updates the configuration of an existing subscription.  **Modifiable Parameters**:  - Billing information (amount, description) - Customer details (contact information, billing/shipping addresses) - Subscription settings (cancelAtPeriodEnd, pauseAtPeriodEnd) - Metadata (for your internal tracking)  **Update Effects**:  - Amount changes apply to the next billing cycle - Customer information updates take effect immediately - Setting `cancelAtPeriodEnd` to true will end the subscription after the current period - Setting `pauseAtPeriodEnd` to true will pause billing after the current period  **Note**: Some fundamental properties cannot be changed once a subscription is created, including currency and billing interval. To modify these, you would need to cancel the existing subscription and create a new one.
     * @summary Update Subscription
     * @param {string} id The subscription ID
     * @param {UpdateSubscriptionRequest} updateSubscriptionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async update(
      id: string,
      updateSubscriptionRequest: UpdateSubscriptionRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Subscription>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.update(
        id,
        updateSubscriptionRequest,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SubscriptionsApi.update']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    }
  };
};

/**
 * SubscriptionsApi - factory interface
 * @export
 */
export const SubscriptionsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = SubscriptionsApiFp(configuration);
  return {
    /**
     * Activates a subscription by attaching a payment method and initiating the billing cycle.  **Activation Process**:  1. This endpoint transitions a `PENDING` subscription to `ACTIVE` status 2. An initial payment is created to validate the payment method:    - For regular subscriptions: First billing cycle payment is processed immediately    - For trial subscriptions: A zero-amount payment is created to verify the payment method  **Payment Method Updates**: If the subscription is already active, this endpoint can be used to update the payment method. The update process creates a zero-amount payment to verify the new payment method works correctly.  **Important Notes**:  - Subscription billing begins immediately upon successful activation (unless in trial period) - The payment method provided will be used for all future recurring charges - Activation failures (due to invalid payment method) will keep the subscription in `PENDING` status
     * @summary Activate Subscription
     * @param {string} id The subscription ID
     * @param {ActivateSubscriptionRequest} [activateSubscriptionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activate(
      id: string,
      activateSubscriptionRequest?: ActivateSubscriptionRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Payment> {
      return localVarFp
        .activate(id, activateSubscriptionRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Cancels an active subscription, permanently stopping the billing cycle.  **Cancellation Effects**:  - The subscription status changes to `CANCELED` - No further charges will be processed - Access to subscription services typically ends immediately or at period end (depending on your business rules)  **Important Notes**:  - Cancellation is permanent and cannot be undone - To restart service, a new subscription must be created - Consider using `pauseAtPeriodEnd` or `cancelAtPeriodEnd` for softer transitions  Use this endpoint when a customer wishes to completely terminate their subscription.
     * @summary Cancel Subscription
     * @param {string} id The subscription ID
     * @param {CancelSubscriptionRequest} [cancelSubscriptionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancel(
      id: string,
      cancelSubscriptionRequest?: CancelSubscriptionRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Subscription> {
      return localVarFp
        .cancel(id, cancelSubscriptionRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Creates a new subscription with the specified parameters.  **Subscription Lifecycle**:  1. When first created, the subscription has a `PENDING` status 2. To initiate billing, you must call the [activate endpoint](https://docs.monei.com/apis/rest/subscriptions-activate/) with payment details 3. Once activated, the subscription will automatically bill according to the configured interval  **Key Configuration Parameters**:  - **Billing settings**: Amount, currency, interval (daily, weekly, monthly, yearly) - **Schedule customization**: Interval count, trial period duration - **Customer information**: Contact details, billing and shipping addresses - **Communication**: Callback URLs for webhook notifications about subscription events  **Best Practices**:  - Set clear, descriptive names for subscriptions to help with identification - Configure appropriate webhook notifications to monitor subscription status changes - Consider offering trial periods to increase customer conversion rates - Use metadata to store additional information relevant to your business logic
     * @summary Create Subscription
     * @param {CreateSubscriptionRequest} createSubscriptionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    create(
      createSubscriptionRequest: CreateSubscriptionRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Subscription> {
      return localVarFp
        .create(createSubscriptionRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves the complete details of an existing subscription by its unique ID.  This endpoint returns comprehensive information about the subscription, including:  - Current status and lifecycle details (active, paused, canceled) - Billing configuration (amount, currency, interval) - Schedule information (current period, next payment date) - Customer and payment method details - Payment history (including last payment status) - Trial period information (if applicable)  Use this endpoint to check subscription status, verify billing details, or retrieve information needed for customer support inquiries.
     * @summary Get Subscription
     * @param {string} id The subscription ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Subscription> {
      return localVarFp.get(id, options).then((request) => request(axios, basePath));
    },
    /**
     * Pauses an active subscription, temporarily halting the billing cycle.  **Pause Effects**:  - Billing is immediately suspended - The subscription status changes to `PAUSED` - No charges will be processed while the subscription remains paused - The current billing period end date remains unchanged  **Use Cases**:  - Temporary service interruptions - Customer vacation or absence periods - Account maintenance or dispute resolution  To resume billing, use the [resume endpoint](https://docs.monei.com/apis/rest/subscriptions-resume/).
     * @summary Pause Subscription
     * @param {string} id The subscription ID
     * @param {PauseSubscriptionRequest} [pauseSubscriptionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pause(
      id: string,
      pauseSubscriptionRequest?: PauseSubscriptionRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Subscription> {
      return localVarFp
        .pause(id, pauseSubscriptionRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Resumes a previously paused subscription, reactivating the billing cycle.  **Resume Effects**:  - Billing is immediately reactivated - The subscription status changes from `PAUSED` to `ACTIVE` - The next billing date is recalculated based on the current date - Regular charging schedule resumes according to the subscription interval  **Important Notes**:  - No immediate charge is created when resuming (billing continues on next scheduled date) - Any pause duration is added to the current billing period, maintaining the expected number of billing cycles - If a significant time has passed, verify that the payment method is still valid
     * @summary Resume Subscription
     * @param {string} id The subscription ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resume(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Subscription> {
      return localVarFp.resume(id, options).then((request) => request(axios, basePath));
    },
    /**
     * Sends a subscription activation link to the customer through their preferred communication channel.  **This API can only be used for subscriptions with the following status:**  - Pending  **Delivery channels are automatically selected based on available customer information:**  - If customer email is available: Link is sent via email - If customer phone is available: Link is sent via WhatsApp - If WhatsApp delivery fails: Link is sent via SMS as a fallback  The subscription activation link allows customers to complete their subscription setup by providing payment details on the secure MONEI payment page. If no customer contact information is provided, the system will use the details stored in the subscription record.
     * @summary Send Subscription Link
     * @param {string} id The subscription ID
     * @param {SendSubscriptionLinkRequest} [sendSubscriptionLinkRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendLink(
      id: string,
      sendSubscriptionLinkRequest?: SendSubscriptionLinkRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Subscription> {
      return localVarFp
        .sendLink(id, sendSubscriptionLinkRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Sends subscription status information to the customer through their preferred communication channel.  **This API can only be used for subscriptions with the following statuses:**  - Active - Trialing - Past due  **Delivery channels are automatically selected based on available customer information:**  - If customer email is available: Status is sent via email - If customer phone is available: Status is sent via WhatsApp - If WhatsApp delivery fails: Status is sent via SMS as a fallback  The status notification includes subscription details such as current status, upcoming payments, and recent changes. If no customer contact information is provided, the system will use the details stored in the subscription record.  **Email notifications include contextual action links based on subscription status:**  - For past due subscriptions: A link to reactivate the subscription - For active and trialing subscriptions: A link to update the payment method  You can specify the customer\'s email or phone number, the preferred communication channel (email or SMS), and the language for the message.
     * @summary Send Subscription Status
     * @param {string} id The subscription ID
     * @param {SendSubscriptionStatusRequest} [sendSubscriptionStatusRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendStatus(
      id: string,
      sendSubscriptionStatusRequest?: SendSubscriptionStatusRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Subscription> {
      return localVarFp
        .sendStatus(id, sendSubscriptionStatusRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Updates the configuration of an existing subscription.  **Modifiable Parameters**:  - Billing information (amount, description) - Customer details (contact information, billing/shipping addresses) - Subscription settings (cancelAtPeriodEnd, pauseAtPeriodEnd) - Metadata (for your internal tracking)  **Update Effects**:  - Amount changes apply to the next billing cycle - Customer information updates take effect immediately - Setting `cancelAtPeriodEnd` to true will end the subscription after the current period - Setting `pauseAtPeriodEnd` to true will pause billing after the current period  **Note**: Some fundamental properties cannot be changed once a subscription is created, including currency and billing interval. To modify these, you would need to cancel the existing subscription and create a new one.
     * @summary Update Subscription
     * @param {string} id The subscription ID
     * @param {UpdateSubscriptionRequest} updateSubscriptionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    update(
      id: string,
      updateSubscriptionRequest: UpdateSubscriptionRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Subscription> {
      return localVarFp
        .update(id, updateSubscriptionRequest, options)
        .then((request) => request(axios, basePath));
    }
  };
};

/**
 * SubscriptionsApi - object-oriented interface
 * @export
 * @class SubscriptionsApi
 * @extends {BaseAPI}
 */
export class SubscriptionsApi extends BaseAPI {
  /**
   * Activates a subscription by attaching a payment method and initiating the billing cycle.  **Activation Process**:  1. This endpoint transitions a `PENDING` subscription to `ACTIVE` status 2. An initial payment is created to validate the payment method:    - For regular subscriptions: First billing cycle payment is processed immediately    - For trial subscriptions: A zero-amount payment is created to verify the payment method  **Payment Method Updates**: If the subscription is already active, this endpoint can be used to update the payment method. The update process creates a zero-amount payment to verify the new payment method works correctly.  **Important Notes**:  - Subscription billing begins immediately upon successful activation (unless in trial period) - The payment method provided will be used for all future recurring charges - Activation failures (due to invalid payment method) will keep the subscription in `PENDING` status
   * @summary Activate Subscription
   * @param {string} id The subscription ID
   * @param {ActivateSubscriptionRequest} [activateSubscriptionRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  public activate(
    id: string,
    activateSubscriptionRequest?: ActivateSubscriptionRequest,
    options?: RawAxiosRequestConfig
  ) {
    return SubscriptionsApiFp(this.configuration)
      .activate(id, activateSubscriptionRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Cancels an active subscription, permanently stopping the billing cycle.  **Cancellation Effects**:  - The subscription status changes to `CANCELED` - No further charges will be processed - Access to subscription services typically ends immediately or at period end (depending on your business rules)  **Important Notes**:  - Cancellation is permanent and cannot be undone - To restart service, a new subscription must be created - Consider using `pauseAtPeriodEnd` or `cancelAtPeriodEnd` for softer transitions  Use this endpoint when a customer wishes to completely terminate their subscription.
   * @summary Cancel Subscription
   * @param {string} id The subscription ID
   * @param {CancelSubscriptionRequest} [cancelSubscriptionRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  public cancel(
    id: string,
    cancelSubscriptionRequest?: CancelSubscriptionRequest,
    options?: RawAxiosRequestConfig
  ) {
    return SubscriptionsApiFp(this.configuration)
      .cancel(id, cancelSubscriptionRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Creates a new subscription with the specified parameters.  **Subscription Lifecycle**:  1. When first created, the subscription has a `PENDING` status 2. To initiate billing, you must call the [activate endpoint](https://docs.monei.com/apis/rest/subscriptions-activate/) with payment details 3. Once activated, the subscription will automatically bill according to the configured interval  **Key Configuration Parameters**:  - **Billing settings**: Amount, currency, interval (daily, weekly, monthly, yearly) - **Schedule customization**: Interval count, trial period duration - **Customer information**: Contact details, billing and shipping addresses - **Communication**: Callback URLs for webhook notifications about subscription events  **Best Practices**:  - Set clear, descriptive names for subscriptions to help with identification - Configure appropriate webhook notifications to monitor subscription status changes - Consider offering trial periods to increase customer conversion rates - Use metadata to store additional information relevant to your business logic
   * @summary Create Subscription
   * @param {CreateSubscriptionRequest} createSubscriptionRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  public create(
    createSubscriptionRequest: CreateSubscriptionRequest,
    options?: RawAxiosRequestConfig
  ) {
    return SubscriptionsApiFp(this.configuration)
      .create(createSubscriptionRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves the complete details of an existing subscription by its unique ID.  This endpoint returns comprehensive information about the subscription, including:  - Current status and lifecycle details (active, paused, canceled) - Billing configuration (amount, currency, interval) - Schedule information (current period, next payment date) - Customer and payment method details - Payment history (including last payment status) - Trial period information (if applicable)  Use this endpoint to check subscription status, verify billing details, or retrieve information needed for customer support inquiries.
   * @summary Get Subscription
   * @param {string} id The subscription ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  public get(id: string, options?: RawAxiosRequestConfig) {
    return SubscriptionsApiFp(this.configuration)
      .get(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Pauses an active subscription, temporarily halting the billing cycle.  **Pause Effects**:  - Billing is immediately suspended - The subscription status changes to `PAUSED` - No charges will be processed while the subscription remains paused - The current billing period end date remains unchanged  **Use Cases**:  - Temporary service interruptions - Customer vacation or absence periods - Account maintenance or dispute resolution  To resume billing, use the [resume endpoint](https://docs.monei.com/apis/rest/subscriptions-resume/).
   * @summary Pause Subscription
   * @param {string} id The subscription ID
   * @param {PauseSubscriptionRequest} [pauseSubscriptionRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  public pause(
    id: string,
    pauseSubscriptionRequest?: PauseSubscriptionRequest,
    options?: RawAxiosRequestConfig
  ) {
    return SubscriptionsApiFp(this.configuration)
      .pause(id, pauseSubscriptionRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Resumes a previously paused subscription, reactivating the billing cycle.  **Resume Effects**:  - Billing is immediately reactivated - The subscription status changes from `PAUSED` to `ACTIVE` - The next billing date is recalculated based on the current date - Regular charging schedule resumes according to the subscription interval  **Important Notes**:  - No immediate charge is created when resuming (billing continues on next scheduled date) - Any pause duration is added to the current billing period, maintaining the expected number of billing cycles - If a significant time has passed, verify that the payment method is still valid
   * @summary Resume Subscription
   * @param {string} id The subscription ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  public resume(id: string, options?: RawAxiosRequestConfig) {
    return SubscriptionsApiFp(this.configuration)
      .resume(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Sends a subscription activation link to the customer through their preferred communication channel.  **This API can only be used for subscriptions with the following status:**  - Pending  **Delivery channels are automatically selected based on available customer information:**  - If customer email is available: Link is sent via email - If customer phone is available: Link is sent via WhatsApp - If WhatsApp delivery fails: Link is sent via SMS as a fallback  The subscription activation link allows customers to complete their subscription setup by providing payment details on the secure MONEI payment page. If no customer contact information is provided, the system will use the details stored in the subscription record.
   * @summary Send Subscription Link
   * @param {string} id The subscription ID
   * @param {SendSubscriptionLinkRequest} [sendSubscriptionLinkRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  public sendLink(
    id: string,
    sendSubscriptionLinkRequest?: SendSubscriptionLinkRequest,
    options?: RawAxiosRequestConfig
  ) {
    return SubscriptionsApiFp(this.configuration)
      .sendLink(id, sendSubscriptionLinkRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Sends subscription status information to the customer through their preferred communication channel.  **This API can only be used for subscriptions with the following statuses:**  - Active - Trialing - Past due  **Delivery channels are automatically selected based on available customer information:**  - If customer email is available: Status is sent via email - If customer phone is available: Status is sent via WhatsApp - If WhatsApp delivery fails: Status is sent via SMS as a fallback  The status notification includes subscription details such as current status, upcoming payments, and recent changes. If no customer contact information is provided, the system will use the details stored in the subscription record.  **Email notifications include contextual action links based on subscription status:**  - For past due subscriptions: A link to reactivate the subscription - For active and trialing subscriptions: A link to update the payment method  You can specify the customer\'s email or phone number, the preferred communication channel (email or SMS), and the language for the message.
   * @summary Send Subscription Status
   * @param {string} id The subscription ID
   * @param {SendSubscriptionStatusRequest} [sendSubscriptionStatusRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  public sendStatus(
    id: string,
    sendSubscriptionStatusRequest?: SendSubscriptionStatusRequest,
    options?: RawAxiosRequestConfig
  ) {
    return SubscriptionsApiFp(this.configuration)
      .sendStatus(id, sendSubscriptionStatusRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Updates the configuration of an existing subscription.  **Modifiable Parameters**:  - Billing information (amount, description) - Customer details (contact information, billing/shipping addresses) - Subscription settings (cancelAtPeriodEnd, pauseAtPeriodEnd) - Metadata (for your internal tracking)  **Update Effects**:  - Amount changes apply to the next billing cycle - Customer information updates take effect immediately - Setting `cancelAtPeriodEnd` to true will end the subscription after the current period - Setting `pauseAtPeriodEnd` to true will pause billing after the current period  **Note**: Some fundamental properties cannot be changed once a subscription is created, including currency and billing interval. To modify these, you would need to cancel the existing subscription and create a new one.
   * @summary Update Subscription
   * @param {string} id The subscription ID
   * @param {UpdateSubscriptionRequest} updateSubscriptionRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  public update(
    id: string,
    updateSubscriptionRequest: UpdateSubscriptionRequest,
    options?: RawAxiosRequestConfig
  ) {
    return SubscriptionsApiFp(this.configuration)
      .update(id, updateSubscriptionRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
